var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === "mousemove")?_c('div',{on:{"mousemove":_vm.mouseMove,"touchmove":_vm.touchMove}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }